import { withInstall } from '@lit-element/utils'
import CascaderPanel from './src/index.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCascaderPanel: SFCWithInstall<typeof CascaderPanel> =
  withInstall(CascaderPanel)

export default LtCascaderPanel
export * from './src/types'
export * from './src/config'
export * from './src/instance'
